import {
  Box,
  Button,
  Container,
  Link,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { toggleOnboarding } from "../../../features/onboarding/onboarding.slice";
import { PricingPlans } from "../../Subscriptions/partials/PricingPlans";
import { Logo } from "../../../components";

import AmazonImage from "../../../assets/promotion/amazon.png";
import AutoOpenImage from "../../../assets/promotion/auto-open.png";
import AnalyzeImage from "../../../assets/promotion/analyze.png";
import { useNavigate } from "react-router-dom";

const STEPS = [
  {
    image: AmazonImage,
    title: "Open any amazon product page",
    description: "Go to Amazon and click on any product you want to analyze.",
  },
  {
    image: AutoOpenImage,
    title: "SellerScout will open automatically",
    description:
      "Your extension will load instantly on the right side of the listing.",
  },
  {
    image: AnalyzeImage,
    title: "Start analyzing key data",
    description:
      "See ROI, fees, charts, IP alerts, competition, variations, and more.",
  },
];

export const ExtensionSignupOnboarding = () => {
  const dispatch = useAppDispatch();
  const { data: pricingPlans } = useAppSelector((state) => state.pricingPlans);
  const theme = useTheme();
  const mdDown = useMediaQuery(theme.breakpoints.down("md"));
  const smDown = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  // const plans = pricingPlans.map((plan) =>
  //   plan.name.toLowerCase() === "free"
  //     ? {
  //         ...plan,
  //         onChange() {
  //           dispatch(toggleOnboarding(false));
  //         },
  //       }
  //     : plan,
  // );

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
      <Typography
        textAlign="center"
        fontSize={{ xs: 24, md: 30 }}
        fontWeight={700}
        letterSpacing={"-0.75px"}
        lineHeight={{ md: "36px" }}
      >
        Welcome to SellerScout!
        <br />
        Your All-In-One Amazon Research Tool
      </Typography>
      <Typography
        sx={{
          color: "#45454C",
          fontWeight: 400,
          fontSize: "16px",
          lineHeight: "18.4px",
          textAlign: "center",
        }}
      >
        Every Amazon product page now comes with powerful new data
      </Typography>

      <Box
        display="flex"
        flexDirection={mdDown ? "column" : "row"}
        gap="60px"
        justifyContent="center"
        alignItems="flex-start"
        marginTop="67px"
      >
        {STEPS.map((step, index) => (
          <Stack
            alignItems="center"
            justifyContent="center"
            width={mdDown ? "100%" : "275px"}
          >
            <Box>
              <img src={step.image} />
            </Box>
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "22px",
                lineHeight: "36px",
                marginTop: "8px",
              }}
            >
              Step {index + 1}
            </Typography>
            <Box
              border="0.5px solid #181D1F26"
              borderRadius="8px"
              padding="20px"
              textAlign="center"
              marginTop="16px"
              minHeight={mdDown ? "unset" : "175px"}
            >
              <Typography
                sx={{
                  color: "#111111",
                  fontWeight: 600,
                  fontSize: "22px",
                  lineHeight: "28px",
                }}
              >
                {step.title}
              </Typography>
              <Typography
                sx={{
                  color: "#45454C",
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: "18.4px",
                  marginTop: "16px",
                }}
              >
                {step.description}
              </Typography>
            </Box>
          </Stack>
        ))}
      </Box>
      <Button
        variant="contained"
        sx={{
          height: "48px",
          marginTop: "44px",
          fontSize: "20px",
          paddingX: "24px",
        }}
        onClick={() => {
          window.open("https://www.amazon.com/dp/B0CRWRY5RM", "_blank");
          navigate(`/product-analyzer?asin=B0CRWRY5RM`);
        }}
      >
        Analyze Your First Product
      </Button>
    </Box>
  );
};

export default ExtensionSignupOnboarding;
